// ./src/contexts/TasksContext/TasksContext.tsx
//
// Thin context wrapper around the useTasks hook. All derived data lives in the
// hook itself. See PointsOfInterestContext for the pattern.

import React, { createContext, useContext } from "react";

import { useTasks, UseTasksOptions, UseTasksReturn } from "@/hooks/useTasks";

const TasksContext = createContext<UseTasksReturn | null>(null);

export interface TasksProviderProps extends UseTasksOptions {
  children: React.ReactNode;
}

export const TasksProvider: React.FC<TasksProviderProps> = ({ children, ...options }) => {
  const value = useTasks(options);

  return <TasksContext.Provider value={value}>{children}</TasksContext.Provider>;
};

export const useTasksContext = (): UseTasksReturn => {
  const context = useContext(TasksContext);

  if (!context) {
    throw new Error(
      "useTasksContext must be used within a <TasksProvider>. " +
        "Wrap your component tree with <TasksProvider> to fix this."
    );
  }

  return context;
};

export const useOptionalTasksContext = (): UseTasksReturn | null => {
  return useContext(TasksContext);
};
